module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "sellersResults"
  }, [_c('thead', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.idtfr')))]), _vm._v(" "), _c('th', {
    staticClass: "showLargeScreenOnly",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.social_reason')))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "40%"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.kyc_status')))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "40%"
    }
  }, [_vm._v(_vm._s('Actions'))])]), _vm._v(" "), _c('tbody', [(_vm.sellers.length > 0) ? _vm._l((_vm.sellers), function(seller) {
    return _c('tr', {
      key: seller.IdSeller,
      staticClass: "boxRequest",
      style: ({
        background: _vm.getSeenStatusBackground(seller.TotalToValidateDocuments),
        fontWeight: _vm.getSeenStatusFontWeight(seller.TotalToValidateDocuments)
      })
    }, [(_vm.LMSGsupplierconfig) ? _c('td', [_vm._v(_vm._s(seller.SellerIdentifier))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(seller.Siren))]), _vm._v(" "), _c('td', {
      staticClass: "showLargeScreenOnly"
    }, [_vm._v(_vm._s(seller.SocialReason))]), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "icon list-icon",
      class: _vm.getKYCIcon(seller)
    }), _vm._v("\n          " + _vm._s(_vm.getKYCStatus(seller)) + "\n        ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "color": "var(--actionButtonColor)"
      }
    }, [(false) ? _c('div', [_c('span', {
      staticClass: "fileClickButton",
      staticStyle: {
        "margin-right": "20px"
      },
      on: {
        "click": function($event) {
          return _vm.seeSupplierDetails(seller, 'details')
        }
      }
    }, [_vm._v("\n              Design 1\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "fileClickButton",
      staticStyle: {
        "margin-right": "20px"
      },
      on: {
        "click": function($event) {
          return _vm.seeSupplierDetails(seller, 'kycform')
        }
      }
    }, [_vm._v("\n              Design 2\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "fileClickButton",
      on: {
        "click": function($event) {
          return _vm.seeSupplierDetails(seller, 'docform')
        }
      }
    }, [_vm._v("\n              Design 3\n            ")])]) : _c('div', [(_vm.$engine.user.get().identifier === 'backoffice@demosoft.com') ? _c('div', [_c('span', {
      staticClass: "fileClickButton",
      on: {
        "click": function($event) {
          return _vm.seeSupplierDetails(seller, 'kycform')
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm.$t('common.vrf')) + "\n              ")])]) : _c('div', [_c('span', {
      staticClass: "fileClickButton",
      staticStyle: {
        "margin-right": "20px"
      },
      on: {
        "click": function($event) {
          return _vm.seeSupplierDetails(seller, 'kycform')
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm.$t('common.cnslt')) + "\n              ")]), _vm._v(" "), _c('span', {
      staticClass: "fileClickButton",
      on: {
        "click": function($event) {
          return _vm.seeSupplierDetails(seller, 'details')
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm.$t('creation_forms.vldt')) + "\n              ")])])])])])
  }) : _c('tr', [_c('td', {
    staticClass: "noResult",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('common.no_result')) + "\n      ")])])], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-08595c12", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08595c12","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/requests/SuppliersList.vue
// module id = 2321
// module chunks = 2